var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnPaymentDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discover-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 100,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M24.12 60H96c2.2 0 4-1.8 4-4V33.7S73.2 51.87 24.12 60z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-610 -264) translate(610 264)"
  }, /*#__PURE__*/React.createElement("mask", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 59,
    x: 0.5,
    y: 0.5,
    stroke: "#E6772F",
    rx: 4
  })), /*#__PURE__*/React.createElement("mask", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E6772F",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M18.3 29.82c-.76.64-1.72.92-3.25.92h-.63v-7.66h.63c1.53 0 2.45.27 3.24.94.8.7 1.3 1.77 1.3 2.88 0 1.12-.5 2.23-1.3 2.92zm-2.77-8.7h-3.47v11.6h3.45c1.84 0 3.17-.43 4.33-1.35 1.38-1.1 2.2-2.74 2.2-4.45 0-3.42-2.68-5.8-6.5-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M23.1 21.12h2.37v11.6H23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M31.24 25.56c-1.42-.5-1.83-.83-1.83-1.45 0-.72.75-1.27 1.77-1.27.7 0 1.3.27 1.9.93l1.24-1.54c-1-.86-2.22-1.3-3.54-1.3-2.15 0-3.78 1.44-3.78 3.32 0 1.6.76 2.42 2.97 3.2.93.3 1.4.5 1.64.65.46.28.7.7.7 1.18 0 .94-.78 1.64-1.84 1.64-1.12 0-2.03-.54-2.57-1.55l-1.54 1.4c1.1 1.54 2.4 2.22 4.2 2.22 2.44 0 4.17-1.58 4.17-3.82 0-1.84-.8-2.68-3.5-3.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M35.47 26.92c0 3.4 2.8 6.04 6.4 6.04 1 0 1.88-.2 2.95-.67v-2.67c-.95.9-1.78 1.27-2.85 1.27-2.38 0-4.06-1.65-4.06-4 0-2.22 1.75-3.98 3.97-3.98 1.12 0 1.97.38 2.95 1.3v-2.65c-1.03-.5-1.88-.7-2.9-.7-3.58 0-6.45 2.68-6.45 6.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M63.95 28.9l-3.23-7.78h-2.57L63.28 33h1.26l5.24-11.88h-2.56l-3.27 7.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M70.85 32.7h6.7v-1.96H73.2v-3.12h4.18v-1.97H73.2v-2.57h4.34v-1.96h-6.7v11.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M82.15 26.45h-.68v-3.5h.72c1.47 0 2.26.6 2.26 1.72 0 1.16-.8 1.78-2.3 1.78zm4.74-1.9c0-2.18-1.57-3.43-4.3-3.43h-3.5v11.6h2.37v-4.67h.3l3.27 4.66h2.9l-3.8-4.88c1.77-.34 2.75-1.5 2.75-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6772F",
    d: "M58.48 26.94c0 3.34-2.83 6.04-6.3 6.04-3.5 0-6.32-2.7-6.32-6.04 0-3.33 2.82-6.03 6.3-6.03 3.5 0 6.32 2.7 6.32 6.04"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnPaymentDiscover);
export default __webpack_public_path__ + "static/media/cn-payment-discover.b44f9aac86919a0b110379aea33f2536.svg";
export { ForwardRef as ReactComponent };